import { Link, useLocation } from "react-router-dom";
import { Calendar } from "lucide-react";

/**
 * Global floating "Book Now" button — sits above the WhatsApp FAB.
 * Hidden on the schedule page itself to avoid redundancy.
 */
export const BookNowFab = () => {
  const { pathname } = useLocation();
  if (pathname === "/schedule" || pathname === "/book") return null;

  return (
    <Link
      to="/schedule"
      data-testid="book-now-fab"
      aria-label="Book a class"
      className="fixed bottom-20 right-5 z-50 group flex items-center gap-2 px-4 py-3 rounded-full bg-brand-yellow text-black font-black text-xs uppercase tracking-wider shadow-[0_8px_30px_rgba(255,218,31,0.45)] hover:scale-105 hover:bg-brand-yellowHover transition-all glow-yellow"
    >
      <Calendar size={18} />
      <span className="hidden sm:inline">Book a Class</span>
    </Link>
  );
};
